<template lang="html">
  <div :class="content.type">
    <div class="actions">
      <div class="radio-wrap" v-for="(c, i) in content.options" :key="i" :class="getClass(i+1)" @click="setClass(i+1,c)">
        <label class="radio-container" :for="'radio'+i">{{ c.label }}
          <input type="radio" name="radios" :id="'radio'+i" :value="c.value">
          <span class="radiomark"></span>
        </label>
      </div>
    </div>
    
    <button v-if="!chosen" disabled class="btn btn-outline-light btn-lg remix-next">Next</button>
    <div v-for="(t, i) in targets" :key="'tar'+i">
      <router-link v-if="target == t":to="{ name: 'questions', params: {from: slug, q: getQ(t)} }" class="btn btn-outline-light btn-lg remix-next" :class="buttonAble(abled)">Next</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'content',
    'slug',
  ],
  data() {
    return {
      chosen: false,
      formValue: false,
      target: false,
      formKey: false,
      abled: false,
    }
  },
  methods: {
    buttonAble(abled) {
      return abled ? "" : "disabled";
    },
    setClass(i,c) {
      this.chosen = i;
      this.formValue = c.value;
      this.target = c.target;
      this.formKey = this.content.prop;
      this.abled = true;
      //this.setFormVal({prop: this.formKey, value: this.formValue, group: this.content.group});
      this.setFormVal({prop: this.formKey, value: this.formValue, group: this.content.group, report: this.totalScore, score: c.score, serial: c.serial, id: parseInt(this.$router.currentRoute.params.q)});
      this.$store.commit('setNext',this.nextQ);
    },
    getClass(i){
      return (i == this.chosen) ? 'chosen' : '';
    },
    getQ(slug) {
      return this.$store.state.content[slug].id;
    },
    setFormVal(payload){
      this.$store.commit('setFormData',payload);
      //this.$store.commit('setFormGroupData',payload);
    }
  },
  computed: {
    totalScore() {
      // for max val
      let type = this.content.type;
      let scores = [];
      this.content.options.forEach((v)=>{
        let score = v.score ? v.score : 0;
        scores.push(score);
      });
      return (Math.max.apply(null, scores) > 0) ? Math.max.apply(null, scores) : false;
    },
    nextQ() {
      let con = this.content;
      return this.chosen ? this.getQ(con.options[this.chosen - 1].target) : this.getQ(con.options[0].target);
    },
    targets() {
      let opt = this.content.options;
      let tar = [];
      opt.forEach(function(v){
        tar.push(v.target);
      });
      return Array.from(new Set(tar));
    }
  },
  beforeRouteUpdate(to, from , next) {
      //this.$store.state.formData[this.formKey] = this.formValue;
      //this.chosen = false;
      next();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars';
@import '../../assets/scss/mixins';

.actions {
  text-align: left;
  margin-bottom: gu(1.5);
}

.radio-wrap {
  margin-bottom: gu(2);

  @media only screen and (min-width: 40rem) {
    margin-bottom: rem-calc(12);
  }
}
</style>
